module.exports = __webpack_public_path__ + "static/img/4963_phase_function_Paper_Points.899e6f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4963_phase_function_Paper_Points.png
// module id = iR4N
// module chunks = 0